import React, {useContext} from "react";
import {
  MenuItem,
  MenuList,
  Paper,
  Popover,
  Typography
} from "@material-ui/core";
import CmtAvatar from "../../../../@coremat/CmtAvatar";
import ArrowDropDownIcon from "@material-ui/icons/ArrowDropDown";
import makeStyles from "@material-ui/core/styles/makeStyles";
import {useDispatch, useSelector} from "react-redux";
import {AuhMethods} from "../../../../services/auth";
import {CurrentAuthMethod} from "../../../constants/AppConstants";
import ExitToAppIcon from "@material-ui/icons/ExitToApp";
import PersonIcon from "@material-ui/icons/Person";
import SettingsIcon from "@material-ui/icons/Settings";
import ArrowBackIosIcon from "@material-ui/icons/ArrowBackIos";
import ArrowLeftIcon from "@material-ui/icons/ArrowLeft";
import SidebarThemeContext from "../../../../@coremat/CmtLayouts/SidebarThemeContext/SidebarThemeContext";
import {auth, Principal} from "@codeArt/auth";
import {App} from "@codeArt/apps";
import HomeIcon from "@material-ui/icons/Home";
import { fetchStart } from "redux/actions";
import { createIcon } from "@codeArt/components/common";
import clsx from "clsx";

const useStyles = makeStyles(theme => ({
  root: {
    padding: "16px 16px 12px 16px",
    borderBottom: props => `solid 1px ${props.sidebarTheme.borderColor}`,
    display:"flex",
    flexDirection:"column"
  },
  moduleIcon:{
    background:"rgb(0, 123, 255)"
  },
  userInfo: {
    paddingTop: 16,
    transition: "all 0.1s ease",
    // height: 75,
    opacity: 1,
    ".Cmt-miniLayout .Cmt-sidebar-content:not(:hover) &": {
      height: 0,
      paddingTop: 0,
      opacity: 0,
      transition: "all 0.3s ease"
    }
  },
  userTitle: {
    color: props => props.sidebarTheme.textDarkColor,
    marginBottom: 0
  },
  userSubTitle: {
    fontSize: 14,
    fontWeight: theme.typography.fontWeightBold,
    letterSpacing: 0.25
  }
}));

const SidebarHeader = () => {
  const dispatch = useDispatch();

  const sidebar = useSelector(({app}) => app.sidebar);
  let { module } = sidebar;

  return (
    module?<ModuleInfo />:<UserInfo />
  );
};

export default SidebarHeader;



const UserInfo = () => {
  const {sidebarTheme} = useContext(SidebarThemeContext);
  const classes = useStyles({sidebarTheme});
  const dispatch = useDispatch();

  const [ anchorEl, setAnchorEl ] = React.useState(null);

  const sidebar = useSelector(({app}) => app.sidebar);
  let {passage} = sidebar;

  const handlePopoverOpen = event => {
    setAnchorEl(event.currentTarget);
  };

  const handlePopoverClose = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);

  const onLogoutClick = () => {
    handlePopoverClose();

    // dispatch(fetchStart());
    let principal = new Principal({dispatch});
    principal.signOut();
    // window.location.reload();
  };

  const getMenus = () => {
    return (
      <MenuList>
        {
          passage?.map(({label,icon,onClick},i)=>{
            return (
              <MenuItem key={`menu-${i}`} onClick={(e)=>{ handlePopoverClose(); onClick(e);}}>
                {icon}
                <div className="ml-2">{label}</div>
              </MenuItem>
            );
          })
        }
        <MenuItem onClick={onLogoutClick}>
          <ExitToAppIcon />
          <div className="ml-2">{"退出"}</div>
        </MenuItem>
      </MenuList>
    );
  };

  const user = useSelector(({auth}) => auth.authUser) || {};
  return (
    <div className={classes.root}>
      <CmtAvatar src={user.Photo} />
      <div className={classes.userInfo} onClick={handlePopoverOpen}>
        <div
          className={"pointer"}
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "flex-end"
          }}
        >
          <div className="mr-2">
            <Typography
              className={classes.userTitle}
              component="h3"
              variant="h6"
            >
              {user.RealName || user.Name}
            </Typography>
            {/* <Typography className={classes.userSubTitle}>技术工程师</Typography> */}
          </div>
          <ArrowDropDownIcon />
        </div>
      </div>

      {open && (
        <Popover
          open={open}
          anchorEl={anchorEl}
          container={anchorEl}
          onClose={handlePopoverClose}
          anchorOrigin={{vertical: "center", horizontal: "right"}}
          transformOrigin={{vertical: "center", horizontal: "right"}}
        >
          <Paper elevation={8}>{getMenus()}</Paper>
        </Popover>
      )}
    </div>
  );
};


const ModuleInfo = () => { //子模块信息
  const {sidebarTheme} = useContext(SidebarThemeContext);
  const classes = useStyles({sidebarTheme});
  const dispatch = useDispatch();

  const sidebar = useSelector(({app}) => app.sidebar);
  const {module} = sidebar;
  const {title,icon} = module;

  return (
    <div className={classes.root}>
      <CmtAvatar className={classes.moduleIcon}>
      {createIcon(icon,"text-white")}
      </CmtAvatar>
      <div className={classes.userInfo}>
        <div
          className={"pointer"}
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "flex-end"
          }}
        >
          <div className="mr-2">
            <Typography
              className={classes.userTitle}
              component="h3"
              variant="h6"
            >
              {title}
            </Typography>
          </div>
        </div>
      </div>
    </div>
  );
};
